import { Plus } from 'lucide-react'

/**
 * Props for VariantSelectButton component
 */
export interface VariantSelectButtonProps {
  // Click handler
  onClick: () => void

  // Button text
  text: string

  // Optional disabled state
  disabled?: boolean
}

/**
 * Shared Button UI for Variant Selection
 *
 * Simple presentational component that renders the green "Select Variant(s)" button.
 * Used by ProductVariantButton and ProductVariantSelector to avoid duplicating button JSX.
 *
 * @example
 * <VariantSelectButton
 *   onClick={handleOpenModal}
 *   text="Select Variants"
 *   disabled={!productId}
 * />
 */
export function VariantSelectButton({
  onClick,
  text,
  disabled = false,
}: VariantSelectButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="w-full flex items-center gap-2 px-3 py-2 rounded-md border-[1px] border-brand-hover bg-surface-hover hover:bg-surface-hover-deep transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <Plus size={16} className="text-brand" />
      <span className="font-medium text-sm text-brand">{text}</span>
    </button>
  )
}
